import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const MinusIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <rect x="2" y="7" width="12" height="2" rx="1" />
    </SvgIcon>
  );
};
